import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import { Loading } from "./components";


const ClientPage = lazy(() => import("./pages/env_client"));
const EnvPage = lazy(() => import("./pages/Environnement/Environnement"));
const LoginPage = lazy(() => import("./pages/login"));

const ResetPasswordPage = lazy(() => import("./pages/reset_password"));
const ForgetPassword = lazy(() => import("./components/reset_password"));
const Dashboard = lazy(() => import("./pages/dashboard"));
const ActifsPage = lazy(() => import("./pages/actifs"));
const EntitéGéoPage = lazy(() => import("./pages/site"));
const ArborescenceActif = lazy(() => import("./pages/arborescence_actif"));
const ClasseursPage = lazy(() => import("./pages/classeurs"));
const GexBox = lazy(() => import("./pages/gexbox"));
const ProtectRoutes = lazy(() => import("./utils/ProtectedRoutes"));
const EditUser = lazy(() => import("./pages/settings"));

const EnvSimulator = lazy(() => import("./pages/env_simulator"));
const Emulator = lazy(() => import("./pages/emulator"));
const Fonciere = lazy(() => import("./pages/fonciere"));
const RapportsPage = lazy(()=>import("./pages/rapports"));

function App() {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/emulator_login/:p1/:p2" element={<Emulator />} />
        <Route path="/reset-password/:id" element={<ResetPasswordPage />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route element={<ProtectRoutes />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/liste-actifs" element={<ActifsPage />} />
          <Route path="/environnement/:id_env_arcgis" element={<EnvPage />} />
          <Route path="/entité-géospatiale" element={<EntitéGéoPage />} />
          <Route path="/actif/:uuid" element={<ArborescenceActif />} />
          <Route path="/classeurs" element={<ClasseursPage />} />
          <Route path="/gexbox" element={<GexBox />} />
          <Route path="/environnement-client" element={<ClientPage />} />
          <Route path="/settings" element={<EditUser />} />
          <Route path="/env_simulator/:p1/:p2" element={<EnvSimulator/>} />
          <Route path="/entité-foncière" element={<Fonciere />} />
          <Route path="/rapport" element={<RapportsPage />} />

        </Route>
      </Routes>
    </Suspense>

  );
}

export default App;
